import { render, staticRenderFns } from "./MelosSquareButton.vue?vue&type=template&id=1722bd58&scoped=true&"
import script from "./MelosSquareButton.vue?vue&type=script&lang=ts&"
export * from "./MelosSquareButton.vue?vue&type=script&lang=ts&"
import style0 from "./MelosSquareButton.vue?vue&type=style&index=0&id=1722bd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1722bd58",
  null
  
)

export default component.exports